export default function ProfileSingleAchievements(props: any) {
  return <div>ProfileSingleAchievements.ui</div>;
}
